module.exports = __webpack_public_path__ + "img/figure04.05b3a77b.png";